import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faCheckDouble } from '@fortawesome/free-solid-svg-icons'
import './login.css'
import { useNavigate } from 'react-router-dom';
import { useAuthServices } from '../../services/useFetch';
import logoAgendate from '../../img/logoAgendate4.png'
import { useSearchParams } from "react-router-dom";
import { ENUM_QUERY_PARAMS } from '../../utils/Enumerados';

export const LoginAgendaTe = ({ setSelectActionPublicZone }) => {

  const { requestPost } = useAuthServices();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (searchParams.has(ENUM_QUERY_PARAMS.USUARIO_ACTION_PASS_ID)) {
      const id = searchParams.get(ENUM_QUERY_PARAMS.USUARIO_ACTION_PASS_ID);
      setFormStateValue({
        ...formStateValue,
        usuario: id
      })
      setSelectActionView('ACTUALIZA_PASS_AGENDATE')
    }
  }, [])

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const [selectActionView, setSelectActionView] = useState('LOGIN_AGENDATE')

  const [modalInfo, setModalInfo] = useState(false)
  const [modalInfo1, setModalInfo1] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [modalError1, setModalError1] = useState(false)

  const [showMsgLogin, setShowMsgLogin] = useState(false)
  const [showMsgPass, setShowMsgPass] = useState(false)
  const [showMsgErrorPass, setShowMsgErrorPass] = useState(false)
  const [showMsgErrorEmail, setShowMsgErrorEmail] = useState(false)

  const [formStateValue, setFormStateValue] = useState({
    usuario: '',
    contrasenia: '',
  })

  const [formState, setFormState] = useState({
    usuarioRef: false,
    contraseniaRef: false,
  })

  const { usuario, contrasenia } = formStateValue;
  const { usuarioRef, contraseniaRef } = formState;

  const [formStateValuePass, setFormStateValuePass] = useState({
    contraseniaAct: '',
    contraseniaConfirmaAct: '',
  })

  const [formStatePass, setFormStatePass] = useState({
    contraseniaActRef: false,
    contraseniaConfirmaActRef: false,
  })

  const { contraseniaAct, contraseniaConfirmaAct } = formStateValuePass;
  const { contraseniaActRef, contraseniaConfirmaActRef } = formStatePass;

  const [formStateValueRecuperaPass, setFormStateValueRecuperaPass] = useState({
    correoUsuario: '',
  })

  const [formStateRecuperaPass, setFormStateRecuperaPass] = useState({
    correoUsuarioRef: false,
  })

  const { correoUsuario } = formStateValueRecuperaPass;
  const { correoUsuarioRef } = formStateRecuperaPass;

  const changeInputRecuperaPass = (e) => {
    setFormStateValueRecuperaPass({
      ...formStateValueRecuperaPass,
      [e.target.name]: e.target.value
    })
  }

  const changeInputPass = (e) => {
    setFormStateValuePass({
      ...formStateValuePass,
      [e.target.name]: e.target.value
    })
  }

  const changeInput = (e) => {
    setFormStateValue({
      ...formStateValue,
      [e.target.name]: e.target.value
    })
  }

  const actionLogin = () => {
    let formValidado = [];
    setFormState({
      usuarioRef: false,
      contraseniaRef: false,
    })

    if (!usuario && usuario.length === 0) {
      formValidado.push('usuarioRef');
    }

    if (!contrasenia && contrasenia.length === 0) {
      formValidado.push('contraseniaRef');
    }

    if (formValidado.length === 0) {
      loginService()
    } else {
      setFormState({
        usuarioRef: formValidado.includes('usuarioRef'),
        contraseniaRef: formValidado.includes('contraseniaRef'),
      })
      formValidado.splice(0, formValidado.length)
    }
  }

  const loginService = async () => {
    setShowMsgLogin(false)
    const body = {
      "usuario": usuario,
      "contrasenia": contrasenia
    }
    const response = await requestPost(body, 4);
    if (!response.error) {
      const { estado, mensaje, objeto } = response.data
      if (estado) {
        if (mensaje === 'MSG_LOGIN_SUCCES') {
          sessionStorage.setItem('usuarioApp', JSON.stringify(objeto))
          navigate('/zona-trx');
        } else if (mensaje === 'MSG_LOGIN_ACTIVATE') {
          setSelectActionView('ACTUALIZA_PASS_AGENDATE')
        }
      } else {
        setShowMsgLogin(true)
      }
    } else {
      setModalError(true)
    }
  }

  const actionActualizaPass = () => {
    let formValidado = [];
    setShowMsgPass(false)
    setFormStatePass({
      contraseniaActRef: false,
      contraseniaConfirmaActRef: false,
    })

    if (!contraseniaAct && contraseniaAct.length === 0) {
      formValidado.push('contraseniaActRef');
    }

    if (!contraseniaConfirmaAct && contraseniaConfirmaAct.length === 0) {
      formValidado.push('contraseniaConfirmaActRef');
    }

    if (formValidado.length === 0) {
      if (contraseniaAct === contraseniaConfirmaAct) {
        actualizaPassService()
      } else {
        setFormStatePass({
          contraseniaActRef: true,
          contraseniaConfirmaActRef: true,
        })
        setShowMsgPass(true)
      }
    } else {
      setFormStatePass({
        contraseniaActRef: formValidado.includes('contraseniaActRef'),
        contraseniaConfirmaActRef: formValidado.includes('contraseniaConfirmaActRef'),
      })
      formValidado.splice(0, formValidado.length)
    }
  }

  const actualizaPassService = async () => {
    setShowMsgErrorPass(false)
    const body = {
      "usuario": usuario,
      "contrasenia": contraseniaAct
    }
    const response = await requestPost(body, 5);
    if (!response.error) {
      const { estado } = response.data
      if (estado) {
        if (searchParams.has(ENUM_QUERY_PARAMS.USUARIO_ACTION_PASS_ID)) {
          const url = new URL(window.location);
          url.searchParams.delete(ENUM_QUERY_PARAMS.USUARIO_ACTION_PASS_ID);
          window.history.replaceState({}, '', url);
        }
        resetForm()
        setSelectActionView('LOGIN_AGENDATE')
        setModalInfo(true)
      } else {
        setShowMsgErrorPass(true)
      }
    } else {
      setModalError(true)
    }
  }

  const actionRecuperaPass = () => {
    let formValidado = [];
    setFormStateRecuperaPass({
      correoUsuarioRef: false
    })
    setShowMsgErrorEmail(false)

    if (!correoUsuario && correoUsuario.length === 0) {
      formValidado.push('correoUsuarioRef');
    } else {
      const regex = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/;
      if (!regex.test(correoUsuario)) {
        formValidado.push('correoUsuarioRef');
        setShowMsgErrorEmail(true)
      }
    }
    if (formValidado.length === 0) {
      recuperaPassService()
    } else {
      setFormStateRecuperaPass({
        correoUsuarioRef: formValidado.includes('correoUsuarioRef')
      })
      formValidado.splice(0, formValidado.length)
    }
  }

  const recuperaPassService = async () => {
    const body = {
      "correoUsuario": correoUsuario,
    }
    const response = await requestPost(body, 7);
    if (!response.error) {
      const { estado, mensaje } = response.data
      if (estado) {
        resetForm()
        setModalInfo1(true)
      } else {
        if (mensaje === 'AT_BCK_003') {
          setModalError1(true)
        } else {
          setModalError(true)
        }
      }
    } else {
      setModalError(true)
    }
  }

  const resetForm = () => {
    setFormStateValue({
      usuario: '',
      contrasenia: '',
    })
    setFormStateValuePass({
      contraseniaAct: '',
      contraseniaConfirmaAct: '',
    })
    setFormStateValueRecuperaPass({
      correoUsuario: ''
    })
  }

  const handleCloseInfo = () => {
    setModalInfo(false)
  };

  const handleCloseInfo1 = () => {
    setModalInfo1(false)
    setSelectActionView('LOGIN_AGENDATE')
  };

  const handleCloseError = () => {
    setModalError(false)
  };

  const handleCloseError1 = () => {
    setModalError1(false)
  };

  const componentValidated = () => {
    switch (selectActionView) {
      case 'LOGIN_AGENDATE':
        return (
          <>
            <div className="row m-0">
              <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
              <div className="col-12 col-sm-12 col-md-10 col-lg-6 p-0">
                <div className='div-login'>
                  <div className='div-login-elements'>
                    <div className='div-elements-children' >
                      <div className='div-titulo-login-logo'>
                        <img src={logoAgendate} alt='logoAgendate' className='img-logo-agendate-login'
                          onClick={() => setSelectActionPublicZone('LANDING_AGENDATE')}>
                        </img>
                        <h3 className='titulo-login-1 mt-3-dgc'>Ingresa a AgendaTe</h3>
                      </div>
                      <div className='div-inputs-login'>
                        <p className='p-label-form'> Usuario </p>
                        <input type="text" name='usuario' className={usuarioRef ? 'form-control form-control-error' : 'form-control'} placeholder='Usuario' autoComplete='off'
                          value={usuario} onChange={changeInput} />
                        <p className='p-label-form'> Contraseña </p>
                        <input type="password" name='contrasenia' className={contraseniaRef ? 'form-control form-control-error' : 'form-control'} placeholder='Contraseña' autoComplete='off'
                          value={contrasenia} onChange={changeInput} />
                        {
                          showMsgLogin ?
                            <p className='frt-message-error'>**Usuario y/o contraseña incorrecto</p>
                            :
                            <p className='frt-message-error'></p>
                        }
                      </div>
                      <div className='div-bottom-custom'>
                        <button className='btn btn-link a-link' onClick={() => setSelectActionView('RECUPERA_PASS_AGENDATE')}>
                          Olvide mi contraseña
                        </button>
                        <button className='bottom-custom' onClick={actionLogin}>
                          Ingresar
                        </button>
                      </div>
                    </div>
                  </div>
                  <p className='p-info-login'>Agenda-te | Todos los derechos reservados </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
            </div>
          </>
        )
      case 'ACTUALIZA_PASS_AGENDATE':
        return (
          <>
            <div className="row m-0">
              <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
              <div className="col-12 col-sm-12 col-md-10 col-lg-6 p-0">
                <div className='div-login'>
                  <div className='div-login-elements'>
                    <div className='div-elements-children' >
                      <div className='div-titulo-login-logo'>
                        <img src={logoAgendate} alt='logoAgendate' className='img-logo-agendate-login'
                          onClick={() => setSelectActionPublicZone('LANDING_AGENDATE')}>
                        </img>
                        <h3 className='titulo-login-1 mt-3-dgc'>Activa tu cuenta</h3>
                      </div>
                      <p>Para activar tu cuenta, bastará con actualizar la contraseña:</p>
                      <div className='div-inputs-login'>
                        <p className='p-label-form'>Nueva contraseña  </p>
                        <input type="password" name='contraseniaAct' className={contraseniaActRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                          value={contraseniaAct} onChange={changeInputPass} />
                        <p className='p-label-form'>Confirma contraseña </p>
                        <input type="password" name='contraseniaConfirmaAct' className={contraseniaConfirmaActRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                          value={contraseniaConfirmaAct} onChange={changeInputPass} />
                        {
                          showMsgPass ?
                            <p className='frt-message-error'>**Las contraseñas no coinciden</p>
                            :
                            <p className='frt-message-error'></p>
                        }
                        {
                          showMsgErrorPass ?
                            <p className='frt-message-error'>**Error al intentar activar la cuenta</p>
                            :
                            <p className='frt-message-error'></p>
                        }
                      </div>
                      <div className='div-bottom-custom'>
                        <div></div>
                        <button className='bottom-custom' onClick={actionActualizaPass}>
                          Actualizar
                        </button>
                      </div>
                    </div>
                  </div>
                  <p className='p-info-login'>Agenda-te | Todos los derechos reservados </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
            </div>
          </>
        )
      case 'RECUPERA_PASS_AGENDATE':
        return (
          <>
            <div className="row m-0">
              <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
              <div className="col-12 col-sm-12 col-md-10 col-lg-6 p-0">
                <div className='div-login'>
                  <div className='div-login-elements'>
                    <div className='div-elements-children' >
                      <div className='div-titulo-registra-logo'>
                        <img src={logoAgendate} alt='logoAgendate' className='img-logo-agendate-login'
                          onClick={() => setSelectActionPublicZone('LANDING_AGENDATE')}>
                        </img>
                      </div>
                      <h3 className='titulo-login-1'>Recupera tu constraseña</h3>
                      <div className='div-inputs-login'>
                        <p className='p-label-form'> Correo registrado </p>
                        <input type="text" name='correoUsuario' className={correoUsuarioRef ? 'form-control form-control-error' : 'form-control'} placeholder='Usuario' autoComplete='off'
                          value={correoUsuario} onChange={changeInputRecuperaPass} />
                        {
                          showMsgErrorEmail ?
                            <p className='frt-message-error'>**El correo ingresado no está en un formato válido.</p>
                            :
                            <></>
                        }
                      </div>
                      <div className='div-bottom-custom'>
                        <button className='btn btn-link a-link' onClick={() => setSelectActionView('LOGIN_AGENDATE')}>
                          Volver
                        </button>
                        <button className='bottom-custom' onClick={actionRecuperaPass}>
                          Recuperar contraseña
                        </button>
                      </div>
                    </div>
                  </div>
                  <p className='p-info-login'>Agenda-te | Todos los derechos reservados </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
            </div>
          </>
        )
      default:
        return (
          <></>
        )
    }
  }

  return (
    <>
      <div className='div-container'>
        {
          componentValidated()
        }
      </div>
      <Modal isOpen={modalInfo} onHide={handleCloseInfo} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>¡Todo listo para AgendaTe!!! <FontAwesomeIcon icon={faCheckDouble} className='icon-check' /></h4>
        </ModalHeader>
        <ModalBody>
          <p className='mt-2'>Tu cuenta ha sido activada exitosamente.</p>
          <br />
          <p className='mt-2'>
            A partir de este momento, tienes acceso total a todos nuestros servicios, pensados para hacer tu experiencia más poderosa, más sencilla y totalmente tuya.
          </p>
          <br />
          <h5>¡Gracias por confiar en nosotros!</h5>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseInfo}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalInfo1} onHide={handleCloseInfo1} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Tu cuenta ha sido restablecida <FontAwesomeIcon icon={faCheckDouble} className='icon-check' /></h4>
        </ModalHeader>
        <ModalBody>
          <p className='mt-2'>Hemos enviado un enlace para restablecer tu contraseña</p>
          <br />
          <p className='mt-2'>
            Revisa tu correo electrónico. Si no lo encuentras en unos minutos, verifica en la carpeta de spam o correo no deseado.
          </p>
          <br />
          <h5>¡Gracias por confiar en nosotros!</h5>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseInfo1}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
        </ModalHeader>
        <ModalBody>
          <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseError}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalError1} onHide={handleCloseError1} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Usuario no encontrado <FontAwesomeIcon icon={faExclamationTriangle} className='icon-warning' /> </h4>
        </ModalHeader>
        <ModalBody>
          <p>No pudimos encontrar una cuenta asociada al correo ingresado. Asegúrate de que esté escrito correctamente o intenta con otro.
            Si crees que es un error, puedes contactarnos para ayudarte.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseError1}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}
